import { render, staticRenderFns } from "./RegestModal.vue?vue&type=template&id=3acd2242"
import script from "./RegestModal.vue?vue&type=script&lang=js"
export * from "./RegestModal.vue?vue&type=script&lang=js"
import style0 from "./RegestModal.vue?vue&type=style&index=0&id=3acd2242&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports